
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/publisher/[slug]",
      function () {
        return require("private-next-pages/publisher/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/publisher/[slug]"])
      });
    }
  